package twist.mena.sports.shared.dto.admin

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class AdminPlayerResponse(
    val id: String,
    @SerialName("name_en") val nameEn: String,
    @SerialName("name_ar") val nameAr: String?,
    val position: String?,
    val nationality: String?,
    @SerialName("date_of_birth") val dateOfBirth: String?,
    @SerialName("vendor_player_id") val vendorPlayerId: String,
    @SerialName("synced_at_utc") val syncedAtUtc: String
)
